import { render, staticRenderFns } from "./detail-master.vue?vue&type=template&id=1a90f186&"
import script from "./detail-master.vue?vue&type=script&lang=js&"
export * from "./detail-master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports